import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Stack,
  Divider,
  Autocomplete,
} from "@mui/material";

/**
 * Props:
 * - open: boolean
 * - onClose: function
 * - onSubmit: function({ cantidadRecibida, fecha, observaciones })
 * - producto: { nombre, cantidadSolicitada, cantidadRecibida, ... }
 */
const RecepcionDialog = ({
  open,
  onClose,
  onSubmit,
  onRegister,
  productosPendientes = [],
  productosRecibidos = [],
  loading = false,
}) => {

  const [cantidadRecibida, setCantidadRecibida] = useState("");
  const [fecha, setFecha] = useState(() => {
    // Default to today
    const d = new Date();
    return d.toISOString().slice(0, 10);
  });
  const [observaciones, setObservaciones] = useState("");
  const [errorCantidad, setErrorCantidad] = useState("");
  const [errorFecha, setErrorFecha] = useState("");
  const [producto, setProducto] = useState(null);

  React.useEffect(() => {
    if (open) {
      setCantidadRecibida("");
      setFecha(new Date().toISOString().slice(0, 10));
      setObservaciones("");
      setErrorCantidad("");
      setErrorFecha("");
    }
  }, [open]);

  const handleSubmit = async () => {
    let valid = true;
    setErrorCantidad("");
    setErrorFecha("");
    if (!producto) {
      setErrorCantidad("Seleccione un producto.");
      valid = false;
    }       
    if (!cantidadRecibida || isNaN(Number(cantidadRecibida)) || Number(cantidadRecibida) <= 0) {
      setErrorCantidad("Ingrese una cantidad válida.");
      valid = false;
    }
   
    if (!valid) {
        return;
    }


    const response = await fetch(process.env.REACT_APP_SERVER_URL+'/api/recepciones-compra', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
      body: JSON.stringify({
        id_orden_compra: producto.id_orden_compra,
        id_producto: producto.id_producto,
        cantidad_recibida: cantidadRecibida,
        estado: producto.cantidad<=productosRecibidos.reduce((acc, curr) => acc + parseFloat(curr.cantidad_recibida), 0)+parseInt(cantidadRecibida) ? "Recibida" : "Aprobada",
        fecha: fecha,
        observaciones: observaciones,
        usuario_receptor: localStorage.getItem('id')
      }),
    });
    if (response.ok) {
      setProducto(null);
      setCantidadRecibida("");
      onSubmit();
      if(producto.cantidad<=productosRecibidos.reduce((acc, curr) => acc + parseFloat(curr.cantidad_recibida), 0)+parseInt(cantidadRecibida)){
        onClose();
        onRegister();
      }
    }
    else{
      alert(response.statusText)
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Registrar Recepción</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>

          {producto && (
            <Box mb={1}>
              <Typography fontWeight={600}>
                Producto:{" "}
                <span style={{ fontWeight: 400 }}>
                  {producto.producto || producto.nombre || "-"}
                </span>
              </Typography>
              <Typography fontSize={14} color="text.secondary">
                Solicitado: {producto.cantidad ?? "-"} &nbsp;|&nbsp; Ya Recibido: {producto.cantidadRecibida ?? 0}
              </Typography>
            </Box>
          )}
            <Autocomplete
                options={productosPendientes}
                getOptionLabel={(option) => option.nombre}
                onChange={(event, value) => setProducto(value)}
                renderInput={(params) => <TextField {...params} placeholder="Producto" />}
            />

          <TextField
            placeholder="Cantidad Recibida"
            type="number"
            value={cantidadRecibida}
            onChange={(e) => setCantidadRecibida(e.target.value)}
            error={!!errorCantidad}
            helperText={errorCantidad}
            fullWidth
            inputProps={{ min: 1 }}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} disabled={loading} variant="outlined" >
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primarybutton"
          sx={{ fontWeight: "bold" }}
          disabled={loading}
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecepcionDialog;
